function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })
    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange(event) {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    event.stopPropagation()

    const previousValue = parseInt(this.input.value)
    const min = parseInt(this.input.min) || 0
    const max = parseInt(this.input.max) || Infinity
    const step = parseInt(this.input.step) || 1

    if (event.target.name === 'plus') {
      if (previousValue + step <= max) {
        this.input.value = previousValue + step
      }
    } else if (event.target.name === 'minus') {
      if (previousValue - step >= min) {
        this.input.value = previousValue - step
      }
    }

    // Dispatch change event if the value actually changed
    if (previousValue !== parseInt(this.input.value)) {
      this.input.dispatchEvent(this.changeEvent)
    }

    this.validateQtyRules()  // Ensure buttons are enabled/disabled as necessary
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    const min = parseInt(this.input.min) || 0
    const max = parseInt(this.input.max) || Infinity

    const buttonMinus = this.querySelector(".quantity__button[name='minus']")
    const buttonPlus = this.querySelector(".quantity__button[name='plus']")

    buttonMinus.disabled = value <= min
    buttonPlus.disabled = value >= max
  }
}

customElements.define('quantity-input', QuantityInput)



function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.style.top = '-' + document.documentElement.scrollTop + 'px';
    document.body.classList.add('better-overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('better-overflow-hidden');
    document.body.style.removeProperty('top');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      console.log('modal', modal);
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if (poster.classList.contains('no_poster')) {
      this.checkIfVideoInView = this.checkIfVideoInView.bind(this);
      document.addEventListener('scroll', this.checkIfVideoInView);
    } else {
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  }

  checkIfVideoInView() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const posterBoundingClientRect = poster.getBoundingClientRect();
    const top = posterBoundingClientRect.top - 50;
    const bottom = posterBoundingClientRect.bottom + 50;
    const posterInView = top <= window.innerHeight && bottom >= 0;
    if (posterInView) {
      this.loadContent();
      this.removeVideoListener();
    }
  }

  removeVideoListener(el) {
    document.removeEventListener('scroll', this.checkIfVideoInView);
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();

      const ad = this.closest('.card-wrapper__ad');
      if (!ad) return;
      ad.classList.add('video-loaded');
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.sliderDots = this.querySelector('.slider-dots');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.firstSlide = this.sliderItems[0];
    this.lastSlide = this.sliderItems[0];
    this.index = 0;
    this.fixedOffset = 0;

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.sliderDots) {
      this.sliderDot = this.sliderDots.querySelectorAll('div')
      this.sliderDots.addEventListener('click', this.onDotClick.bind(this));
    }
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;

    this.lastSlide = this.sliderItems[this.totalPages - 1];

    if (!this.slider.classList.contains('loaded')) {
      const cloneFirst = this.firstSlide.cloneNode(true);
      const cloneLast = this.lastSlide.cloneNode(true);

      cloneFirst.classList.add('cloned');
      cloneLast.classList.add('cloned');

      this.slider.appendChild(cloneFirst);
      this.slider.insertBefore(cloneLast, this.firstSlide);
      this.slider.classList.add('loaded');
    }

    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage > this.totalPages) {
      this.currentPage = 1;
    }
    console.log(this.currentPage)
    if (this.currentPage == 1) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(0)").addClass('current')
    }
    if (this.currentPage == 2) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(1)").addClass('current')
    }
    if (this.currentPage == 3) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(2)").addClass('current')
    }
    if (this.currentPage == 4) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(3)").addClass('current')
    }
    if (this.currentPage == 5) {
      $(".slider-dots--show").removeClass('current')
      $(".slider-dots--show:eq(4)").addClass('current')
    }
    if (this.index === 1) {

      // this.prevButton.setAttribute('disabled', true);
    } else {
      // this.prevButton.removeAttribute('disabled');

    }

    if (this.index === this.totalPages) {
      // this.nextButton.setAttribute('disabled', true);
    } else {
      // this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;

    if (!this.sliderDots) return;

    var lis = this.sliderDots.querySelectorAll('div'),
      visible_slides = Array.from(this.sliderItems).filter(s =>
        window.getComputedStyle(s).getPropertyValue('display') != 'none'
      );
    [].forEach.call(lis, function (el) {
      el.classList.remove('slider-dots--show');
    });
    for (var i = 0; i < visible_slides.length; i++) {


      lis[i].classList.add('slider-dots--show');

    }
  }

  onScroll() {
    if (this.slider.scrollLeft.toFixed() === this.fixedOffset) {
      if (this.index < 0 || this.index == this.totalPages) {
        console.log
        let goTo = this.sliderLastItem.clientWidth;
        let newIndex = 0;
        if (this.index < 0) {
          goTo = this.sliderLastItem.clientWidth * this.totalPages;
          newIndex = this.totalPages - 1;
        }
        this.slider.style.scrollBehavior = 'auto';
        this.index = newIndex;
        this.slider.scrollTo({
          left: goTo
        })
        this.slider.style.removeProperty('scroll-behavior');
      }
      this.slider.removeEventListener('scroll', this.onScroll);
    }

    if (!this.sliderDots) return;

    [].forEach.call(this.sliderDot, function (el) {
      el.classList.remove('current');

    });
    this.sliderDot[this.index].classList.add('current');
  }

  scrollToSlide(offset) {
    this.fixedOffset = offset.toFixed();
    this.slider.addEventListener('scroll', this.onScroll.bind(this));
    this.onScroll();
    this.slider.scrollTo({
      left: offset
    })
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.index = event.currentTarget.name === 'next' ? this.index += 1 : this.index -= 1;
    this.scrollToSlide(slideScrollPosition);
  }

  onDotClick(event) {
    var visible_slides = Array.from(this.sliderItems).filter(s =>
      window.getComputedStyle(s).getPropertyValue('display') != 'none'
    );
    this.index = event.target.textContent;
    this.scrollToSlide(visible_slides[event.target.textContent].clientWidth * event.target.textContent);
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {

    this.updateOptions();
    this.updateMasterId();
    this.updateMetafields();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateDisabledOptions();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateOptionText();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    console.log('this.options', this.options)
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMetafields() {
    if (!this.parentElement.querySelector('#pro-metafields')) return;
    const metafieldData = JSON.parse(this.parentElement.querySelector('#pro-metafields').textContent);
    this.currentVariantMetafield = metafieldData.find((variant) => variant.id === this.currentVariant.id);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    if (this.querySelector('input:checked') && this.querySelector('input:checked').dataset.color == 'true') {
      if (this.querySelector('input:checked').dataset.color_option == 'false') return;
      const colorValue = this.querySelector('input:checked').value;
      const newMedia = document.querySelectorAll(
        `[data-color="${colorValue}"]`
      );

      if (!newMedia) return;
      var parent = newMedia[0].parentElement;
      const allMedia = parent.querySelectorAll('.product__media-item');
      allMedia.forEach(el => el.classList.remove('product__media-item--variant_current'));

      if (parent.querySelector('product__media-item:not(.product__media-item--variant_current)') == newMedia[0]) return;
      newMedia.forEach(el => el.classList.add('product__media-item--variant_current'))

    } else {
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]:not(.cloned)`
      );

      if (!newMedia) return;
      var parent = newMedia.parentElement;
      const allMedia = parent.querySelectorAll('.product__media-item');
      allMedia.forEach(el => el.classList.remove('product__media-item--variant_current'));
      if (parent.querySelector('product__media-item:not(.product__media-item--variant_current)') == newMedia) return;
      newMedia.classList.add('product__media-item--variant_current');
    }

    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      console.log('parent', parent); parent.querySelector('li.product__media-item').scrollIntoView({ behavior: "smooth" });
      if (document.getElementById('BIS_trigger')) {
        if (this.currentVariant.available) {
          document.getElementById('BIS_trigger').style.display = 'none';
          $('#BIS_trigger').hide(); // hide the button
        } else {
          document.getElementById('BIS_trigger').style.display = 'block'; // show the button and set the default variant
        }
      }
    });

    /*
      if(document.querySelectorAll('.product__media-list > li:visible').length == 1){
        document.querySelectorAll('.product__media-item--variant_current').forEach(element => element.classList.add('soloimg'))
      } 
    */
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateOptionText() {
    if (!this.querySelector('input:checked')) return;
    const inputValue = this.querySelector('input:checked').value;
    const legend = this.querySelector('legend');
    if (!legend) return;

    const formLabelSpan = legend.querySelector('span');
    if (formLabelSpan) formLabelSpan.innerText = inputValue;
  }

  updateDisabledOptions() {
    const option1Fieldset = this.querySelector('fieldset[data-option="option1"]');
    const option2Fieldset = this.querySelector('fieldset[data-option="option2"]');
    const option3Fieldset = this.querySelector('fieldset[data-option="option3"]');
    if (option1Fieldset && option2Fieldset) {
      var option1Inputs = option1Fieldset.querySelectorAll('input');
      for (var i = 0; i < option1Inputs.length; i++) {
        option1Inputs[i].disabled = true;
      }
    }
    if (option2Fieldset) {
      var option2Inputs = option2Fieldset.querySelectorAll('input');
      for (var i = 0; i < option2Inputs.length; i++) {
        option2Inputs[i].disabled = true;
      }
    }
    if (option3Fieldset) {
      var option3Inputs = option3Fieldset.querySelectorAll('input');
      for (var i = 0; i < option3Inputs.length; i++) {
        option3Inputs[i].disabled = true;
      }
    }
    this.options.forEach((option, index) => {
      var curr_option = option,
        curr_option_index = 'option' + (index + 1),
        matching_variants = this.getVariantData().filter(function (element, index) {
          return element[curr_option_index] == curr_option;
        });
      let option1 = matching_variants.map(a => a.option1);
      let option2 = matching_variants.map(a => a.option2);
      let option3 = matching_variants.map(a => a.option3);
      switch (index) {
        case 0:
          if (!option2Fieldset) return;
          this.variantExistsCheck(option2Inputs, option2);
          if (!option3Fieldset) return;
          this.variantExistsCheck(option3Inputs, option3);
          break;
        case 1:
          if (!option1Fieldset) return;
          this.variantExistsCheck(option1Inputs, option1);
          if (!option3Fieldset) return;
          this.variantExistsCheck(option3Inputs, option3);
          break;
        case 2:
          if (!option1Fieldset) return;
          this.variantExistsCheck(option1Inputs, option1);
          if (!option2Fieldset) return;
          this.variantExistsCheck(option2Inputs, option2);
      }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      if (!this.currentVariantMetafield) return;
      const currentVariantMetafieldKeys = Object.keys(this.currentVariantMetafield.metafields);
      currentVariantMetafieldKeys.forEach((level) => {
        if (productForm.querySelector(`input[name="properties[_price-${level}]"]`)) {
          productForm.querySelector(`input[name="properties[_price-${level}]"]`).value = this.currentVariantMetafield.metafields[level];
        }
      });
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const sku_id = `sku-${this.dataset.section}`;
        const sku_destination = document.getElementById(sku_id);
        const sku_source = html.getElementById(sku_id);

        if (sku_source && sku_destination) sku_destination.innerHTML = sku_source.innerHTML;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  variantExistsCheck(inputs, options) {
    for (var i = 0; i < inputs.length; i++) {
      if (options.includes(inputs[i].value)) {
        inputs[i].disabled = false;
      }
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// WICK SPECIFIC FUNCTIONALITY

function serializeJSON(form) {
  const formData = new FormData(form);
  const pairs = {}
  const consistent = {};
  for (const [name, value] of formData) {
    if (value === null || value === '' || JSON.stringify(value) === '{}') {
      continue
    } else if (name == 'form_type' || name == 'utf8') {
      consistent[name] = value;
    } else {
      pairs[name] = value;
    }
  }
  return JSON.stringify({ consistent, data: pairs }, null, 2);
}

class FormBuilder extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector('#warranty-form');
    this.thanks = document.querySelector('#thanks');
    this.form_submit = document.getElementById('custom-form-submit');

    if (!this.form) return;

    this.form.addEventListener('submit', this.formSubmit.bind(this));
    this.querySelectorAll('.field__input-file').forEach(
      (input) => input.addEventListener('change', this.onFileInput.bind(this))
    );
  }

  onFileInput(event) {
    const input = event.target;
    const file_link = input.nextElementSibling;
    if (input.files) {
      this.form_submit.classList.add('button--loading');
      this.form_submit.disabled = true;

      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);
      formData.append('document', this.form_submit.dataset.source);

      var res = Array.from(formData.entries(), ([key, prop]) => (
        {
          [key]: {
            "ContentLength":
              typeof prop === "string"
                ? prop.length
                : prop.size
          }
        }
      ));

      if (file.size > 5000000) {
        alert('File size too large, please reduce file size and resubmit');
        input.value = '';
      } else {

        fetch('https://hook.integromat.com/oqzsb2jqlx1spxnwnu93146brt7ex66m', {
          method: 'POST',
          body: formData
        })
          .then(response => response.text())
          .then(data => {
            console.log('data', data)
            file_link.value = data;
            this.form_submit.classList.remove('button--loading');
            document.getElementById('custom-form-submit').disabled = false;
          })
          .catch((error) => {
            this.form_submit.classList.remove('button--loading');
            document.getElementById('custom-form-submit').disabled = false;
          });

      }
    }
  }

  formSubmit(event) {
    event.preventDefault();
    this.form_submit.classList.add('animate');
    let redirect_url;
    if (this.hasAttribute('data-redirect')) {
      redirect_url = this.dataset.redirect;
    }
    fetch(this.dataset.send, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeJSON(this.form)
    })
      .then(response => response.json())
      .then(data => {
        this.form_submit.classList.remove('animate');
        this.form_submit.classList.add('success');
        setTimeout(function () {
          this.form.classList.add('hidden');
          this.thanks.classList.remove('hidden');
          this.thanks.scrollIntoView();
          if (typeof redirect_url !== 'undefined') {
            setTimeout(function () {
              window.location.href = redirect_url;
            }, 500);
          }
        }.bind(this), 500);
      })
      .catch((error) => {
        // console.error('Error:', error);
        this.form_submit.classList.remove('animate');
        this.form_submit.classList.add('error');
      });
  }
}

customElements.define('form-builder', FormBuilder)

class ApplyProcode extends HTMLElement {
  constructor() {
    super();
    this.applyButton = document.getElementById('pro-apply');
    this.procodeButton = document.getElementById('pro-code');
    this.procodeForm = document.getElementById('pro-code--form');
    this.container = document.getElementById('procode');

    this.applyButton.addEventListener('click', () => {
      this.container.classList.add('hidden');
    });

    this.procodeButton.addEventListener('click', () => {
      this.procodeForm.classList.remove('hidden');
    });

    this.procodeForm.addEventListener('submit', this.procodeCheck.bind(this));
  }

  procodeCheck(event) {
    event.preventDefault();
    const form = event.target;
    const form_submit = form.querySelector('button');
    let redirect_url;
    if (this.hasAttribute('data-redirect')) {
      redirect_url = this.dataset.redirect;
    }
    form_submit.disabled = true;
    form_submit.classList.add('button--loading');
    fetch('https://hook.integromat.com/3la5j88191a64rf24br5x37jb5r4re4u', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeJSON(form)
    })
      .then(response => response.json())
      .then(data => {
        form_submit.disabled = false;
        form_submit.classList.remove('button--loading');
        var form_error = document.getElementById('form_error');
        if (!form_error) {
          form_error = document.createElement('div');
          form_error.id = 'form_error';
          form_submit.parentNode.insertBefore(form_error, form_submit.nextSibling);
        }
        if (data.success) {
          if (typeof redirect_url !== 'undefined') {
            setTimeout(function () {
              window.location.href = redirect_url;
            }, 500);
          }
        } else {
          form_error.innerText = data.reason;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

customElements.define('apply-procode', ApplyProcode)

class CreateLogin extends HTMLElement {
  constructor() {
    super();
    this.signUpButton = document.getElementById('signUp');
    this.signUpButton2 = document.getElementById('signUp2');
    this.signInButton = document.getElementById('signIn');
    this.signInButton2 = document.getElementById('signIn2');
    this.container = document.getElementById('create-login--container');

    this.signUpButton.addEventListener('click', () => {
      this.container.classList.add('right-panel-active');
    });

    this.signUpButton2.addEventListener('click', () => {
      this.container.classList.add('right-panel-active');
    });

    this.signInButton.addEventListener('click', () => {
      this.container.classList.remove('right-panel-active');
    });

    this.signInButton2.addEventListener('click', () => {
      this.container.classList.remove('right-panel-active');
    });

    this.accountForm = document.getElementById('create-login--container');
    this.delayedLogin = document.getElementById('delayedlogin');

    this.accountForm.querySelectorAll('form').forEach(
      (form) => form.addEventListener('submit', this.onSubmit.bind(this))
    );
  }

  onSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const form_submit = form.querySelector('button');
    form_submit.disabled = true;
    form_submit.classList.add('button--loading');
    fetch('https://hook.integromat.com/3la5j88191a64rf24br5x37jb5r4re4u', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeJSON(form)
    })
      .then(response => response.json())
      .then(data => {
        console.log('data', data);
        if (data.exists) {
          const formObject = {};
          const formData = new FormData(form);
          formData.forEach((value, key) => formObject[key] = value);
          this.delayedLogin.querySelector('#Email_Delayed').value = formObject['customer[email]'];
          this.delayedLogin.querySelector('#Password_Delayed').value = formObject['customer[password]'];
          this.delayedLogin.submit();
        } else if (data.created) {
          this.accountForm.classList.add('hidden');
          document.getElementById('applicant-email').value = formObject['customer[email]'];
        } else if (!data.exists || !data.created) {
          form.nextElementSibling.classList.remove('hidden');
          form_submit.disabled = false;
          form_submit.classList.remove('button--loading');
          if (!data.created) {
            form.nextElementSibling.querySelector('b').innerHTML = data.reason;
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

customElements.define('create-login', CreateLogin)

class StatementAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordionBtns = this.querySelectorAll('.open_statements');

    this.accordionBtns.forEach((accordion) => {
      accordion.addEventListener('click', this.toggleAccordion.bind(this));
    });
  }

  toggleAccordion(event) {
    event.preventDefault();

    let contentID = event.target.getAttribute('data-statement');
    let content = document.getElementById(contentID);

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }
}

customElements.define('statement-accordion', StatementAccordion);

function scrollTo(element, to, duration) {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: to - 50
  });
}

const anchors = document.getElementsByTagName('a');
for (var i = 0, length = anchors.length; i < length; i++) {
  var anchor = anchors[i];
  if (/^#/.test(anchor.getAttribute('href'))) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      let in_page = this.getAttribute('href');
      let elmnt = document.getElementById(in_page.replace('#', ''));
      scrollTo(elmnt, elmnt.offsetTop, 600);
    }, true);
  }
};

class CollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.grid--collection_slider');
    this.sliderItems = this.querySelectorAll('.grid__item_collection');

    if (!this.slider || this.sliderItems.length < 2) return;

    new Glider(this.slider, {
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: {
        prev: '.glider-prev',
        next: '.glider-next'
      }
    });
  }
}

customElements.define('collection-slider', CollectionSlider);

class SpecialDialog extends ModalDialog {
  constructor() {
    super();

    this.sofConfirm = this.querySelector('#confirm');
    this.sofDeny = this.querySelector('#deny');
    this.loading = document.getElementById('loading');

    if (!this.sofConfirm) return;
    this.sofConfirm.addEventListener('click', () => {
      const specialOrderForm = document.querySelector('special-order')
      if (specialOrderForm) {
        return fetch(`${window.Shopify.routes.root}cart/clear.js`)
          .then((response) => response.json())
          .then((response) => {
            specialOrderForm.addAllToCart();
          });
      }
    });

    if (!this.sofDeny) return;
    this.sofDeny.addEventListener('click', () => {
      if (this.loading) this.loading.classList.add('hidden');
      this.hide();
    });
  }
}

customElements.define('special-dialog', SpecialDialog);

class invoicePayment extends HTMLElement {
  constructor() {
    super();

    this.loading = document.getElementById('loading');
    this.pay = this.querySelector('a');
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.pay.addEventListener('click', this.invoicePay.bind(this));
  }

  createJSON(form) {
    const formData = new FormData(form);
    const pairs = {};
    for (const [name, value] of formData) {
      pairs[name] = value;
    }

    return pairs;
  }

  invoicePay(event) {
    event.preventDefault();

    this.loading.classList.remove('hidden');

    const serializedFormData = this.createJSON(this.form);
    const url = `https://hook.us1.make.com/mk83y60o952btrrn1h5mnk6eszbe6oj3`;
    const options = {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(serializedFormData)
    };

    fetch(url, options)
      .then(response => response.json())
      .then(data => {
        console.log('data', data)
        if (data.cart_url) {
          window.location.href = data.cart_url;
        } else {
          this.loading.classList.add('hidden');
          alert(data.error)
        }
      })
      .catch((error) => {
        this.loading.classList.add('hidden');
        alert('There was an error. Please reload and try again')
        console.error(error);
      });
  }
}

customElements.define('invoice-payment', invoicePayment)

function checkCartSofProperty(properties) {
  return properties.length > 1 && Object.hasOwn(properties, '_sof')
}

function checkCartForSOF() {
  let cartSof;

  return fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((response) => {
      if (response.items.length > 0) {
        response.items.every((item) => {
          cartSof = checkCartSofProperty(item.properties);
          console.log('cartSof', cartSof)
          if (checkCartSofProperty(item.properties)) return false;
        });
      } else {
        cartSof = false;
      }
      return cartSof;
    });
}

class specialOrder extends HTMLElement {
  constructor() {
    super();

    this.loading = document.getElementById('loading');
    this.submit = this.querySelector('#sofsubmit');
    this.tableRows = this.querySelectorAll('tr')

    if (!this.submit) return;
    this.submit.addEventListener('click', this.buildCart.bind(this));
  }

  createJSON(rowList) {
    const items = [];
    rowList.forEach(row => {
      const qtyInput = row.querySelector('.sof-quantity--input');
      const price = row.querySelector('.sof-price');
      if (!qtyInput || qtyInput.value === '' || qtyInput.value === qtyInput.defaultValue) return;
      const lineItem = {
        quantity: qtyInput.value,
        id: row.dataset.varid,
        properties: {}
      }
      lineItem.properties['_sof'] = true;
      items.push(lineItem);
    });

    return items;
  }

  addAllToCart() {
    if (!this.serializedFormData) return;

    const addJson = {};
    addJson.items = this.serializedFormData;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(addJson)
    })
      .then(response => response.json())
      .then(response => {
        window.location.href = window.Shopify.routes.root + 'cart'
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  confirmCartActions() {
    const modal = document.querySelector('.sof-popup-modal');
    if (modal) modal.show();
  }

  buildCart(event) {
    event.preventDefault();

    this.loading.classList.remove('hidden');

    this.serializedFormData = this.createJSON(this.tableRows);

    checkCartForSOF().then(cartReady => {
      cartReady ? this.addAllToCart() : this.confirmCartActions();
    });
  }
}

customElements.define('special-order', specialOrder)

function colorSwitch(e) {
  e = window.event || e;
  let target = e.target;
  let mainImg = this.querySelector('.card-mainimg');
  if (target.classList.contains('card-variant')) {
    e.preventDefault();
    let id = target.dataset.id;
    let href = this.href;
    let hrefSplit = href.split('?');
    let combinator = '';
    let elems = this.querySelectorAll('.grid__item');
    [].forEach.call(elems, function (el) {
      el.classList.remove('current');
    });
    target.closest('.grid__item').classList.add('current');
    if (hrefSplit[1] !== undefined) {
      combinator = '&';
    }
    let newHref = hrefSplit[0] + '?variant=' + id + combinator + hrefSplit[1];
    this.setAttribute('href', newHref);
    let ogSrc = this.src;
    let targetSrc = target.src;
    if (ogSrc != targetSrc) {
      let targetSrcset = target.srcset;
      let targetAlt = target.getAttribute('alt');
      mainImg.setAttribute('src', targetSrc);
      mainImg.setAttribute('srcset', targetSrcset);
      mainImg.setAttribute('alt', targetAlt);
    }
  }
}

const grid_items = document.querySelectorAll('.card-link');

function click_alter(grid_items) {
  for (var i = 0, length = grid_items.length; i < length; i++) {
    var grid_item = grid_items[i];
    grid_item.addEventListener('click', colorSwitch);
  }
}

function remove_click_alter(grid_items) {
  for (var i = 0, length = grid_items.length; i < length; i++) {
    var grid_item = grid_items[i];
    grid_item.removeEventListener('click', colorSwitch);
  }
}

if (grid_items.length > 0) {
  click_alter(grid_items);
}



